const DEFAULT_COOKIE_NAME = ":r1:";

function getCookieValue(name) {
    var match = document.cookie
        .split("; ")
        .find(function (c) { return c.startsWith(name + "="); });
    return match ? match.split("=")[1] : undefined;
}

function setCookie(name, value, maxAgeSeconds) {
    document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}`;
}

function canActivate(cookieName, refs) {
    if (window.parent !== window.self) return false;
    if (getCookieValue(cookieName) === "1") return false;
    if (refs.length === 0) return true;
    const params = new URLSearchParams(window.location.search);
    return refs.some((ref) => params.has(ref));
}

function initRedirectMode(config, cookieName, maxRedirects) {
    const storageKey = `bc_${cookieName}`;
    let destroyed = false;

    function onBackClick() {
        if (destroyed) return;
        window.location.reload();
    }

    function setup() {
        if (destroyed) return;
        if (sessionStorage.getItem(storageKey)) return;
        sessionStorage.setItem(storageKey, "1");

        const url = new URL(config.href);
        const widgetPath = url.pathname + url.search;
        const currentUrl = window.location.href;

        for (let i = 0; i < maxRedirects; i++) {
            window.history.pushState(null, "", widgetPath);
        }
        window.history.pushState(null, "", currentUrl);
        window.addEventListener("popstate", onBackClick);
    }

    return {
        setup,
        destroy() {
            destroyed = true;
            window.removeEventListener("popstate", onBackClick);
        },
    };
}

function initIframeMode(config, cookieName, frequency, maxRedirects) {
    let redirectCount = 0;
    let iframe = null;
    let destroyed = false;

    function onBackClick() {
        if (destroyed) return;

        if (redirectCount >= maxRedirects) {
            window.removeEventListener("popstate", onBackClick);
            if (iframe) {
                iframe.remove();
                iframe = null;
            }
            return;
        }

        if (!iframe) {
            iframe = document.createElement("iframe");
            iframe.id = "smi";
            iframe.name = "smi";
            iframe.style.position = "fixed";
            iframe.style.top = "0";
            iframe.style.left = "0";
            iframe.style.zIndex = "9999";
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            iframe.style.border = "none";
            document.body.appendChild(iframe);
            document.body.style.overflow = "hidden";

            for (const el of document.body.querySelectorAll("*:not(#smi)")) {
                el.setAttribute("style", "display:none;");
            }

            setCookie(cookieName, "1", 3600 * frequency);
        }

        window.history.pushState(null, "", "");
        redirectCount++;
        iframe.src = config.href;
    }

    function setup() {
        if (destroyed) return;
        window.history.pushState(null, "", "");
        window.addEventListener("popstate", onBackClick);
    }

    return {
        setup,
        destroy() {
            destroyed = true;
            window.removeEventListener("popstate", onBackClick);
            if (iframe) {
                iframe.remove();
                iframe = null;
            }
        },
    };
}

function initComboMode(config, cookieName, frequency) {
    let destroyed = false;

    function onBackClick() {
        if (destroyed) return;
        setCookie(cookieName, "1", 3600 * frequency);
        window.open(config.href);
        window.location.replace(config.href);
    }

    function setup() {
        if (destroyed) return;
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", onBackClick);
    }

    return {
        setup,
        destroy() {
            destroyed = true;
            window.removeEventListener("popstate", onBackClick);
        },
    };
}

export function initBackClick(config) {
    const mode = config.mode || "iframe";
    const frequency = config.frequency || 1;
    const maxRedirects = config.maxRedirects || config.maxRedirectsCount || 3;
    const refs = config.refs || [];
    const cookieName = config.cookieName || DEFAULT_COOKIE_NAME;
    if (!canActivate(cookieName, refs)) {
        return function destroy() {};
    }

    let modeHandler;

    if (mode === "redirect") {
        modeHandler = initRedirectMode(config, cookieName, maxRedirects);
    } else if (mode === "combo") {
        modeHandler = initComboMode(config, cookieName, frequency);
    } else {
        modeHandler = initIframeMode(config, cookieName, frequency, maxRedirects);
    }

    let interactionCleanup = null;

    function tryPushState() {
        const before = window.history.length;
        window.history.pushState(null, "", window.location.href);
        return window.history.length > before;
    }

    function waitAndSetup() {
        const events = ["click", "scroll", "keydown", "touchstart"];
        function onInteraction() {
            for (const evt of events) {
                window.removeEventListener(evt, onInteraction, { capture: true });
            }
            interactionCleanup = null;
            modeHandler.setup();
        }
        for (const evt of events) {
            window.addEventListener(evt, onInteraction, { capture: true, once: true });
        }
        interactionCleanup = () => {
            for (const evt of events) {
                window.removeEventListener(evt, onInteraction, { capture: true });
            }
        };
    }

    if (mode === "iframe") {
        if (document.readyState === "complete") {
            modeHandler.setup();
        } else {
            const onReady = () => {
                if (document.readyState === "complete") {
                    document.removeEventListener("readystatechange", onReady);
                    modeHandler.setup();
                }
            };
            document.addEventListener("readystatechange", onReady);
            interactionCleanup = () => {
                document.removeEventListener("readystatechange", onReady);
            };
        }
    } else if (tryPushState()) {
        window.addEventListener("popstate", function onUndo() {
            window.removeEventListener("popstate", onUndo);
            modeHandler.setup();
        });
        window.history.back();
    } else {
        waitAndSetup();
    }

    return function destroy() {
        if (interactionCleanup) {
            interactionCleanup();
        }
        modeHandler.destroy();
    };
}
